export default __webpack_public_path__ + "static/media/sponsor_logo_white_mx.1ac39130.svg";